"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Field_1 = __importDefault(require("../components/Field"));
var Label_1 = __importDefault(require("../components/Label"));
var InputField_1 = __importDefault(require("./InputField"));
var TextField = function (_a) {
    var name = _a.name, label = _a.label, size = _a.size, readOnly = _a.readOnly, toolTip = _a.toolTip, maxLength = _a.maxLength, defaultValue = _a.defaultValue, placeholder = _a.placeholder, isUpperCase = _a.isUpperCase;
    return (react_1.default.createElement(Field_1.default, null,
        label && react_1.default.createElement(Label_1.default, { htmlFor: name }, label),
        react_1.default.createElement("div", null,
            react_1.default.createElement(InputField_1.default, { name: name, size: size, readOnly: readOnly, toolTip: toolTip, maxLength: maxLength, defaultValue: defaultValue, placeholder: placeholder, isUpperCase: isUpperCase }))));
};
TextField.defaultProps = {
    size: undefined,
    label: undefined,
    readOnly: false,
    toolTip: undefined,
    maxLength: undefined,
    defaultValue: undefined,
    placeholder: undefined,
    isUpperCase: false,
};
exports.default = TextField;
